import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RegionFilterPipe, ReplaceLineBreaks, SchoolFilterPipe, StatusFilterPipe } from './utils/statusFilter.pipe';

import { DatePipe } from '@angular/common';
import { BrowserXhr } from '@angular/http';
import { NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { OrderByPipe } from 'ng-jhipster';
import {
    AccountService,
    AuthServerProvider,
    AuthService,
    CSRFService,
    HasAnyAuthorityDirective,
    LoginService,
    Principal,
    StateStorageService,
    TmmsaisineSharedCommonModule,
    TmmsaisineSharedLibsModule,
    UserService
} from './';
import { TmmNgbDateParserFormatter } from './datepicker/tmm-dateparserformatter';
import { I18n, TmmDatepickerI18n } from './datepicker/tmm-datepicker-i18n';
import { DisabilityQuestionComponent } from './disability-question/disability-question.component';
import { DownloadService } from './download/download.service';
import { BrowserXhrWithOnProgressSupport } from './upload/browser-xhr-with-on-progress-support';
import { UploadProgressService } from './upload/upload-progress.service';
import { UploadComponent } from './upload/upload.component';
import { UploadService } from './upload/upload.service';
import { AccessibleAutocompleteDirective } from './utils/accessible-autocomplete.directive';
import { AccessiblePopinDirective } from './utils/accessible-popin.directive';
import { CustomDatePipe } from './utils/date.pipe';

@NgModule({
    imports: [
        TmmsaisineSharedLibsModule,
        TmmsaisineSharedCommonModule,
    ],
    declarations: [
        HasAnyAuthorityDirective,
        UploadComponent,
        DisabilityQuestionComponent,
        StatusFilterPipe,
        SchoolFilterPipe,
        RegionFilterPipe,
        ReplaceLineBreaks,
        AccessiblePopinDirective,
        AccessibleAutocompleteDirective,
        CustomDatePipe,
    ],
    providers: [
        CookieService,
        LoginService,
        AccountService,
        StateStorageService,
        Principal,
        CSRFService,
        AuthServerProvider,
        AuthService,
        UserService,
        { provide: NgbDateParserFormatter, useClass: TmmNgbDateParserFormatter },
        { provide: NgbDatepickerI18n, useClass: TmmDatepickerI18n },
        I18n,
        UploadService,
        DownloadService,
        UploadProgressService,
        { provide: BrowserXhr, useClass: BrowserXhrWithOnProgressSupport },
        DatePipe,
        CustomDatePipe,
        OrderByPipe,
    ],
    exports: [
        TmmsaisineSharedCommonModule,
        HasAnyAuthorityDirective,
        CustomDatePipe,
        UploadComponent,
        DisabilityQuestionComponent,
        StatusFilterPipe,
        SchoolFilterPipe,
        RegionFilterPipe,
        ReplaceLineBreaks,
        AccessiblePopinDirective,
        AccessibleAutocompleteDirective
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class TmmsaisineSharedModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared.module.ts